import OreCanvas from "../components/draw/OreCanvas";

export function getBase64(canvas) {
  return canvas.toDataURL("image/png");
}

let captureCanvas = null;

export function convertBase64(img, width, height) {
  if (!captureCanvas) {
    captureCanvas = new OreCanvas(img.width, img.height);
  }
  captureCanvas.clear();

  width = width || img.width;
  height = height || img.height;
  captureCanvas.setSize(width, height);
  captureCanvas.captureImage(img, width, height);
  console.log("img.width, img.height", img.width, img.height);
  console.log(
    "captureCanvas.canvas.width, captureCanvas.canvas.height",
    captureCanvas.canvas.width,
    captureCanvas.canvas.height
  );
  console.log("width, height", width, height);
  return captureCanvas.getBase64();
}

export function drawImage(context, img, x, y, crop, imgRatio = 1) {
  let dx = 0;
  let dy = 0;
  let dw = crop;
  let dh = crop;
  if (x < 0) {
    dx = -x;
    x = 0;
    dw = crop + x;
  }
  if (y < 0) {
    dy = -y;
    y = 0;
    dh = crop + y;
  }

  context.drawImage(img, x / imgRatio, y / imgRatio, crop, crop, dx, dy, dw * imgRatio, dh * imgRatio);
  // context.strokeStyle = "#fff";
  // context.strokeRect(dx, dy, crop, crop);
}
